import { MedicalPaOrdersAuthStatus } from "../enums/medicalPaOrdersAuthStatus";

/**
 * Auth statuses that unlock the Pending# cell when reached directly from
 * `auth_required`.
 */
const PENDING_NUMBER_EDITABLE_AFTER_AUTH_REQUIRED: MedicalPaOrdersAuthStatus[] =
  [
    MedicalPaOrdersAuthStatus.Pending,
    MedicalPaOrdersAuthStatus.AuthByRISA,
    MedicalPaOrdersAuthStatus.DeniedByRISA,
    MedicalPaOrdersAuthStatus.DenialByRISA,
    MedicalPaOrdersAuthStatus.DenialAfterQuery,
    MedicalPaOrdersAuthStatus.ExistingDenial,
  ];

/**
 * Returns whether the Pending# cell should accept input after a PA-required
 * status change.
 *
 * Pending# is locked on initial row generation and only becomes editable when
 * the prior status was `auth_required` and the new status is one of the
 * whitelisted processing/denial outcomes.
 *
 * @param oldAuthStatus - PA-required status before this edit
 * @param newAuthStatus - PA-required status after this edit
 * @return True when Pending# should be editable
 */
export const getPendingNumberEditable = (
  oldAuthStatus: string | undefined,
  newAuthStatus: string | undefined,
): boolean => {
  if (oldAuthStatus !== MedicalPaOrdersAuthStatus.AuthRequired) {
    return false;
  }
  return PENDING_NUMBER_EDITABLE_AFTER_AUTH_REQUIRED.includes(
    newAuthStatus as MedicalPaOrdersAuthStatus,
  );
};
